import { initializeSentry } from "./sentry";

export default function bootstrap() {
  // Init Sentry
  initializeSentry();
}
